import { formatDataTest } from '@/common/dataTest/DataTest';
import { useInDialog } from '@/common/dialog/DialogScopeContext';
import { useFormFieldDef } from '@/common/form/hooks/useFormFieldDef';
import { Autocomplete, TextField } from '@mui/material';
import { useMemo } from 'react';

export const TrxColFormField = ({ trxCols, fieldDef }) => {
  const { value, setValue, onBlur, error, helperText, label, disabled } = useFormFieldDef(fieldDef);
  const inDialog = useInDialog();

  const options = useMemo(() => {
    return trxCols.map(trxCol => {
      return { label: trxCol }
    })
  }, [trxCols])

  const selected = useMemo(
    () => options.find((o) => o.label === value) ?? null,
    [options, value]
  );

  return (
    <Autocomplete 
      data-test-id={formatDataTest(inDialog ? 'dialog' : 'main', 'form-field', fieldDef.displayName)} id={fieldDef.displayName}
      disabled={disabled}
      options={options}
      value={selected}
      onChange={(_, newOption) => setValue(newOption?.label ?? null)}
      onBlur={onBlur}
      isOptionEqualToValue={(opt, val) => opt.label === val.label}
      renderOption={(props, option) => (
        <li {...props} data-test-id={formatDataTest('select', option.label)}>
          {option.label}
        </li>
      )}
      renderInput={(params) => (
        <TextField 
          {...params} 
          label={label}
          error={error}
          helperText={helperText}
        />
      )}
    />
  )
}